import { Component, ViewChild, OnInit, Inject, AfterViewInit } from '@angular/core';
import { MatSidenav } from '@angular/material/sidenav';
import { Router, ActivatedRoute } from "@angular/router"
import { SwUpdate } from '@angular/service-worker';

@Component({
  selector: 'app-loading-screen',
  templateUrl: './loading-screen.component.html',
  styleUrls: ['./loading-screen.component.css']
})
export class LoadingScreenComponent implements OnInit, AfterViewInit {

  title = 'Portal';

  @ViewChild('rightSidenav') public rightsidenav: MatSidenav;
  @ViewChild('sidenav') public sidenav: MatSidenav;

  constructor(
    private swUpdate: SwUpdate,
    private router: Router,
    private route: ActivatedRoute

  ) { }

  apiValues: string[] = [];
  showMenu = false;
  darkModeActive: boolean;

  toggleMenu() {
    if (this.swUpdate.isEnabled) {
      this.swUpdate.available.subscribe((evt) => {
        console.log('service worker updated');
      });

      this.swUpdate.checkForUpdate().then(() => {
      }).catch((err) => {
        console.error('error when checking for update', err);
      });
    }

  }

  modeToggleSwitch() {
  }

  ngOnInit() {
  }

  ngAfterViewInit() {
    this.router.navigate(['/signin'], { relativeTo: this.route }).then(nav => {
    }, err => {
      console.log("Error: " + err)
    }) 
  }

}

export class project {
  public id: string;
  constructor(private swUpdate: SwUpdate) { }

  public value: string;
}

export class employee {
  constructor(
  ) { }
  public id: string;
  public value: string;
}
